export default function input({ variables }) {
    return {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: variables.type_body_font_size,
                    "&.Mui-disabled": {
                        cursor: "not-allowed",
                    },
                    "&::placeholder": {
                        color: variables.text_medium,
                        opacity: 1,
                    },
                },
                multiline: {
                    height: "auto",
                    "&.MuiOutlinedInput-root": {
                        padding: 0,
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottom: `1px solid ${variables.border_strong}`,
                    },
                    "&:after": {
                        borderBottom: `1px solid ${variables.border_strong}`,
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: `1px solid ${variables.border_strong}`,
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                outlined: {
                    color: variables.text_primary,
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    color: variables.text_medium,
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.surface_subtle,
                    borderRadius: variables.border_radius_small,
                    height: variables.component_height_medium,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "&.Mui-focused": {
                        backgroundColor: variables.surface_subtle,
                    },
                    "&.MuiInputBase-sizeSmall": {
                        height: variables.component_height_small,
                    },
                    "&.MuiInputBase-sizeLarge": {
                        height: variables.component_height_large,
                    },
                    "&.MuiInputBase-multiline": {
                        height: "auto",
                        padding: `${variables.spacing_03} ${variables.spacing_04}`,
                    },
                },
                input: {
                    boxSizing: "border-box",
                    height: "100%",
                    paddingTop: variables.spacing_03,
                    paddingBottom: variables.spacing_03,
                    "&.MuiInputBase-inputSizeSmall": {
                        paddingTop: variables.spacing_02,
                        paddingBottom: variables.spacing_02,
                    },
                    "&.MuiInputBase-inputMultiline": {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                },
                underline: {
                    "&:before, &:after": {
                        border: "none",
                    },
                    "&:hover:not(.Mui-disabled, .Mui-error):before": {
                        border: "none",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.surface,
                    height: variables.component_height_medium,
                    "&.MuiInputBase-sizeSmall": {
                        height: variables.component_height_small,
                    },
                    "&.MuiInputBase-sizeLarge": {
                        height: variables.component_height_large,
                    },
                    "&.MuiInputBase-multiline": {
                        height: "auto",
                    },
                },
                input: {
                    boxSizing: "border-box",
                    height: "100%",
                    padding: `${variables.spacing_03} ${variables.spacing_04}`,
                },
                inputSizeSmall: {
                    padding: `${variables.spacing_02} ${variables.spacing_04}`,
                },
                notchedOutline: {
                    borderColor: variables.border_strong,
                },
                adornedStart: {
                    backgroundColor: variables.surface,
                    paddingLeft: variables.spacing_04,
                },
                adornedEnd: {
                    backgroundColor: variables.surface,
                    paddingRight: variables.spacing_04,
                },
                colorSecondary: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: variables.border_strong,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=input.js.map